import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as messageActions from '../../store/modules/messageSlice';
import { bindActionCreators } from 'redux';
import store from '../../store';

const Messages = () => {
    const MessageStates = useSelector((state) => state.message);
    const [visible, setVisible] = useState(false);

    const message = MessageStates.message;
    // let classes = 'toast ' + MessageStates.get('level') + ' ';
    const [classes, setClasses] = useState('toast ' + MessageStates.level + ' ');

    useEffect(() => {
        const status = visible ? 'visible' : '';
        setClasses('toast ' + MessageStates.level + ' ' + status);
    }, [visible]);

    useEffect(() => {
        setVisible(MessageStates.visible);
    }, [MessageStates]);
        
    return (
        <div className={classes} style={{zIndex:9999}}>
            <figure>
                <img alt="" />
            </figure>
            <p>{message}</p>
        </div>
    );
};

const {dispatch} = store;
const MessageActions = bindActionCreators(messageActions, dispatch);
export const showToast = (level, message, time = 1500) => {
    // level : success, danger, warning
    MessageActions.showToast({
        visible: true,
        level: level,
        message: message
    });
    setTimeout(() =>
        MessageActions.hideToast({ visible: false })
    , time);
};

export default Messages;